import { render, staticRenderFns } from "./DeleteCampaignModal.vue?vue&type=template&id=389d9b02&scoped=true&"
import script from "./DeleteCampaignModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCampaignModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCampaignModal.vue?vue&type=style&index=0&id=389d9b02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389d9b02",
  null
  
)

export default component.exports